import IconButton from '@components/v2/ui/IconButton/IconButton';
import useFilterChipStyles from '../../filterChip.styles';
import { FilterChipAction } from '../../filterChip.types';

interface FilterChipActionButtonProps {
  action: FilterChipAction;
}

const FilterChipActionButton = ({ action }: FilterChipActionButtonProps) => {
  const { classes, cx } = useFilterChipStyles();

  return (
    <IconButton
      icon={action.icon}
      size="medium"
      disabled={action.disabled}
      testId={action.testId}
      ariaLabel={action.ariaLabel}
      className={cx(classes.actionButton, action.rotated && classes.rotated)}
      onClick={action.onClick}
    />
  );
};

export default FilterChipActionButton;
